import * as React from 'react'
import { cn } from '@/lib/utils'

/**
 * Ô tích với vùng chạm 44px mà KHÔNG phóng to ô.
 *
 * Ô tích native chỉ 16×16px. Trong bảng đối soát hay danh sách đơn, đó là mục
 * tiêu nhỏ nhất toàn app — bấm trượt là chọn nhầm đơn, mà chọn nhầm đơn trong
 * màn đối soát tiền thì hậu quả không nhỏ.
 *
 * Phóng to ô lên 44px sẽ phá mật độ của bảng. Cách làm ở đây tách hai thứ vốn
 * khác nhau:
 *   - Ô nhìn thấy: giữ 16px, vừa với hàng bảng.
 *   - Vùng bấm: một lớp phủ trong suốt nới ra 44px, nằm ngoài luồng bố cục
 *     (`absolute`) nên không đẩy gì cả.
 *
 * Lớp phủ nằm trong `<label>` nên bấm vào nó vẫn tích đúng ô đó.
 *
 * Ở chế độ desktop không cần nới — chuột trỏ chính xác, và vùng bấm rộng thừa
 * dễ chồng lên hàng bên cạnh trong bảng dày.
 */
export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Nhãn cho trình đọc màn hình — bắt buộc, ô tích không có chữ đi kèm. */
  'aria-label': string
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, ...props }, ref) => (
    <label className="relative inline-flex shrink-0 items-center justify-center">
      <input
        ref={ref}
        type="checkbox"
        className={cn('size-4 cursor-pointer accent-accent', className)}
        {...props}
      />
      {/* -inset-3.5 = −14px mỗi phía: 16 + 28 = 44px. */}
      <span className="absolute -inset-3.5 desktop:hidden" aria-hidden="true" />
    </label>
  ),
)
Checkbox.displayName = 'Checkbox'
